import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import './FandOCard.css';

function FandOCard() {
    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);

    // useEffect(() => {
    //     const getUrl = BaseURL + "MostactiveIndex";
    //     fetch(`${getUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             getData = data.data;
    //             setData(getData);
    //             // console.log(getData, "getData")
    //         })
    //         .catch((error) => {
    //         });
    // }, []);

    useEffect(() => {
        postData('/api/Login/MarketBanner', { Caption: "Future And Options" })
            .then((data) => {

                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    const images = data &&
        data.map(image => {
            return (
                
                <a href={image.bannerUrl} target="_blank" aria-label="Trading View">
                {/* alt="Trading View" */}
                    <img key={image.uploadfile} alt="Trading View" src={BaseLiveURL + "marketimages/" + image.uploadfile} className="img-responsiveFno moreContent" />
                </a>
            )
        });


    return (
        <div className='market-right-scFandO'>
                {images}
            {nodatafound &&
                <p className="textcenter nodata">No Image found !!!</p>
            }
            {/* <div className='ipo-right-pnl'>
                <h2>Most Active Index</h2>
                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                {(data != null) && data.map(
                    ({ Symbol, LTP, UpdTime, ExpDate, OpenInterest, OpenPrice, ClosePrice, HighPrice }) => (
                        <div className="FandOIndex">
                            <div className="FandOInner">
                                <label>Index Name :</label>
                                <p>{Symbol}</p>
                                <label>Expiry Date :</label>
                                <p>{format(parseISO(ExpDate), 'dd-MMM-yyyy')}</p>
                                <label>High Price :</label>
                                <p>{HighPrice.toFixed(2)}</p>
                                <label>Open Price :</label>
                                <p>{OpenPrice.toFixed(2)}</p>
                            </div>
                            <div>
                                <label>LTP (Rs.) :</label>
                                <p>{LTP.toFixed(2)}</p>
                                <label>Open Interest :</label>
                                <p>{OpenInterest.toFixed(2)}</p>
                                <label>Close Price :</label>
                                <p>{ClosePrice.toFixed(2)}</p>
                                <label>Update Time :</label>
                                <p>{format(parseISO(UpdTime), 'dd-MMM-yyyy')}<br></br>{"(" + UpdTime.split('T')[1] + ")"}</p>
                            </div>
                        </div>
                    ))}
                <div className='market-btn'>
                    <a href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Get Started</a>
                </div>
            </div> */}
        </div>
    )
}

export default FandOCard